import { initErrorTracking, setErrorContext } from "@wevideo/platform/errorTracking";

import { getAppVersionNumber } from "../../helpers/GeneralHelper";

// Errors whose stack matches one of these fragments (ad networks, browser
// extensions, third-party widgets) are spam and dropped before being reported.
const SPAM_STACK_FRAGMENTS = [
	"mashfsttest",
	"femurssculler",
	"anyplacetrivial",
	"duckfacedeals",
	"determineyourroad",
	"docketsuncompromising",
	"crashesdisband",
	"slakelegionary",
	"vertamedia",
	"adroll", // ads
	"chrome-extension", // any error thrown by a browser extension
	"ct.pinterest.com", // pinterest pixel
	"s.pinimg.com",
];

// Spam fragments matched against the error message rather than the stack.
const SPAM_MESSAGE_FRAGMENTS = ["react/addons", "twttr"];

const isRunningStandalone = (): boolean => {
	if (typeof window === "undefined") return false;
	const nav = window.navigator as Navigator & { standalone?: boolean };
	const mediaStandalone =
		typeof window.matchMedia === "function" &&
		window.matchMedia("(display-mode: standalone)").matches;
	return mediaStandalone || nav.standalone === true;
};

/**
 * Initializes error tracking for the checkout app, wrapping the shared
 * `@wevideo/platform/errorTracking` module with checkout-specific spam filtering
 * and metadata. `appName: "cart"` identifies checkout as the error source.
 */
export const initCheckoutErrorTracking = () => {
	initErrorTracking({
		appName: "cart",
		appVersion: getAppVersionNumber(),
		spamStackFragments: SPAM_STACK_FRAGMENTS,
		spamMessages: SPAM_MESSAGE_FRAGMENTS,
	});

	// Flag standalone (installed PWA) sessions so reports capture the run context.
	if (isRunningStandalone()) {
		setErrorContext("isStandalone", true);
	}
};
